import { render, staticRenderFns } from "./videoView.vue?vue&type=template&id=7fcd6e32&scoped=true&"
import script from "./videoView.vue?vue&type=script&lang=js&"
export * from "./videoView.vue?vue&type=script&lang=js&"
import style0 from "./videoView.vue?vue&type=style&index=0&id=7fcd6e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcd6e32",
  null
  
)

export default component.exports